import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { finalize, take } from 'rxjs/operators';
import { SeguroAdesaoServices } from 'src/app/services/seguro/seguro-adesao.service';
import { CompSimuladorSeguroComponent } from 'src/app/templates/comp-simulador-seguro/comp-simulador-seguro.component';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskDirective } from 'ngx-mask';
declare var $: any;

@Component({
    selector: 'app-tab2-personalizar',
    templateUrl: './tab2-personalizar.component.html',
    styleUrls: ['./tab2-personalizar.component.css'],
    imports: [CompSimuladorSeguroComponent, ReactiveFormsModule, FormsModule, NgSelectModule, NgxMaskDirective],
    providers: [SeguroAdesaoServices]
})
export class Tab2PersonalizarComponent implements OnInit {

  @Output() eventoSalvar = new EventEmitter<boolean>();
  @ViewChild('compSimuladorSeguro', {static: false}) compSimSeg: CompSimuladorSeguroComponent;

  form: FormGroup = null;

  ocupacoes: any[] = [];
  dados: any;

  loading: boolean = false;

  constructor(private seguroAdesao: SeguroAdesaoServices) { }

  ngOnInit() {
    
    $('[data-toggle="popover"]').popover()

    this.listarOcupacao();

    this.form = new FormGroup({
      codOcupacao: new FormControl(null, [Validators.required]),
      valorRenda: new FormControl(null, [Validators.required]),
      idcAposentado: new FormControl(null, [Validators.required]),
    });

    this.carregarCoberturaDisponivel();
    this.carregarIdadePart();
    this.carregar();
  }

  carregarCoberturaDisponivel(){

    this.seguroAdesao
        .CoberturaDisponivel()
        .pipe(
          take(1)
        )
        .subscribe(
          (res: any) => {
            this.compSimSeg.coberturaMorteDisponivel = res.cobMorte;
            this.compSimSeg.coberturaInvalidezDisponivel = res.cobInvalidez;

            this.compSimSeg.init();
          }
        )
  }

  carregarIdadePart(){

    this.seguroAdesao
          .idadeParticipante()
          .pipe(
            take(1)
          )
          .subscribe(
            (idade: number) => {
              this.compSimSeg.carregarFatoresDeCalculo(idade);
            }
          )
    
  }

  setForm(){

    this.form.get('codOcupacao').setValue(this.dados.COD_OCUPACAO);
    this.form.get('valorRenda').setValue(this.dados.VLR_RENDA);
    this.form.get('idcAposentado').setValue(this.dados.DEC_APOSENTADO);

    this.compSimSeg.idcCobMorte = this.dados.DEC_MORTE == 'S';
    this.compSimSeg.idcCobInvalidez = this.dados.DEC_INVALIDEZ == 'S';
    this.compSimSeg.coberturaMorte =   this.dados.VLR_COBERTURA_MORTE;
    this.compSimSeg.coberturaInvalidez = this.dados.VLR_COBERTURA_INVALIDEZ;

    this.compSimSeg.calcularPremioMorte();
    this.compSimSeg.calcularPremioInvalidez();
    
  }


  listarOcupacao(){

    this.loading = true;

    this.seguroAdesao
        .ListarOcupacao()
        .pipe(
          finalize(() => {this.loading = false})
        )
        .subscribe(
          (res: any[]) => {
            this.ocupacoes = res;
          },
          (http: HttpErrorResponse) => {

          }
        )
  }

  salvar(){
    
    this.loading = true;

    var dados = this.form.value;

    dados.decMorte = this.compSimSeg.idcCobMorte ? 'S' : 'N';
    dados.decInvalidez = this.compSimSeg.idcCobInvalidez ? 'S' : 'N';

    dados.valorCoberturaMorte = this.compSimSeg.coberturaMorte;
    dados.valorCoberturaInvalidez = this.compSimSeg.coberturaInvalidez;

    if(this.compSimSeg.idcCobMorte){      
      dados.valorPremioMorte = this.compSimSeg.premioMorte;
    }else{
      dados.valorPremioMorte = 0
    }
    
    if(this.compSimSeg.idcCobInvalidez){      
      dados.valorPremioInvalidez = this.compSimSeg.premioInvalidez;
    }else{
      dados.valorPremioInvalidez = 0;
    }

    this.seguroAdesao
        .SalvarSimulacao(dados)
        .pipe(
          finalize(() => {this.loading = false})
        )
        .subscribe(
          (res: any) => {

            this.eventoSalvar.emit(true);
            $("#tabAdesaoSeguro a").addClass('disabled');
            $('#tabAdesaoSeguro a#btnTab3').removeClass('disabled').tab('show');
          },
          (http: HttpErrorResponse) => {

          }
        )
  }
  
  carregar(){

    this.loading = true;

    this.seguroAdesao
        .CarregarSimulacao()
        .pipe(
          finalize(() => {this.loading = false})
        )
        .subscribe(
          (res: any) => {
            this.dados = res;

            if(res!=null){
              this.setForm();
            }
            
          },
          (http: HttpErrorResponse) => {

          }
        )
  }

  proximo(){
    this.salvar();    
  }

  voltar(){
    $("#tabAdesaoSeguro a").addClass('disabled');
    $('#tabAdesaoSeguro a#btnTab1').removeClass('disabled').tab('show');
  }

}
